import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const LiveRegion = () => {
  const { pathname } = useLocation();
  const [routeAnnouncement, setRouteAnnouncement] = useState<string | null>(null);

  useEffect(() => {
    const updateAnnouncement = () => {
      if (document.title) {
        setRouteAnnouncement(document.title);
      } else {
        const pageHeader = document.querySelector('h1');
        const content = pageHeader?.innerText;
        setRouteAnnouncement(content || pathname);
      }
    };

    const to = setTimeout(() => {
      updateAnnouncement();
    }, 200);

    return () => {
      clearTimeout(to);
    };
  }, [pathname]);

  return (
    <div className="sr-only" aria-live="polite" aria-atomic data-testid="live-region-alert">
      {routeAnnouncement || null}
    </div>
  );
};

export default LiveRegion;
